var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info-wrapper"},[_c('div',{staticClass:"user-info"},[_c('userToggleMenu',{on:{"onDeconnexion":_vm.handleDeconnexion}},[_c('div',{staticClass:"user-info-inner"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(this.userName))]),_vm._v(" "),_c('div',{staticClass:"societe"},[_vm._v(_vm._s(this.societeNom()))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024dd6f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserInfoHeader.vue
// module id = null
// module chunks = 